import classnames from 'classnames';
import { useNavigate } from 'react-router-dom';

import styles from './TwoColumnCard.module.scss';
import { CardAccent, Column, Props } from './TwoColumnCard.types';

const MAX_ITEMS = 3;

const toneClass = (tone: Column['tone']) => {
  if (tone === 'late') return styles.toneLate;
  if (tone === 'vote') return styles.toneVote;
  return '';
};

const accentClass = (accent: CardAccent) => {
  if (accent === 'sauge') return styles.accentSauge;
  if (accent === 'bluegray') return styles.accentBluegray;
  if (accent === 'gold') return styles.accentGold;
  return styles.accentTerracotta;
};

const renderColumn = (col: Column) => (
  <div className={classnames(styles.col, toneClass(col.tone))}>
    <div className={styles.colHeader}>
      <span>{col.title}</span>
      {col.count > 0 && <span className={styles.count}>{col.count}</span>}
    </div>
    {col.items.length === 0 ? (
      <div className={styles.empty}>{col.empty}</div>
    ) : (
      <div className={styles.items}>
        {col.items.slice(0, MAX_ITEMS).map((item, index) => (
          <div key={index}>{item}</div>
        ))}
      </div>
    )}
  </div>
);

const TwoColumnCard = ({
  title,
  linkLabel,
  linkTo,
  onLinkClick,
  left,
  right,
  accent,
  icon,
}: Props) => {
  const navigate = useNavigate();

  const handleLinkClick = () => {
    onLinkClick?.();
    navigate(linkTo);
  };

  return (
    <section className={styles.card}>
      <header className={classnames(styles.header, accentClass(accent))}>
        <h3 className={styles.title}>
          <span className={styles.iconChip} aria-hidden="true">
            {icon}
          </span>
          {title}
        </h3>
        <button type="button" className={styles.link} onClick={handleLinkClick}>
          {linkLabel}
        </button>
      </header>
      <div className={styles.cols}>
        {renderColumn(left)}
        {renderColumn(right)}
      </div>
    </section>
  );
};

export default TwoColumnCard;
